import React from 'react'
import { connect } from 'react-redux'
import { LgySection } from '../../../components/util/lgy-section/LgySection'
import AccountInformation from '../components/AccountInformation'
import PersonalInformation from '../components/PersonalInformation'

export const UserProfileContainer = ({ user }) =>
  <LgySection id='user-profile-container' header='My Profile' className='user-profile-container'>
    <PersonalInformation user={user} />
    <AccountInformation user={user} />
  </LgySection>

const mapStateToProps = (state) => ({ user: state.currentUser })

export default connect(mapStateToProps)(UserProfileContainer)